export default __webpack_public_path__ + "static/media/defaultAvatar.e2f6dc67.png";